<template>
    <ValidationObserver ref="companyInfo" v-slot="{ handleSubmit, invalid }">
        <b-form @submit.prevent="handleSubmit(updateCompany)">  
            <b-card header-tag="header" footer-tag="footer" class="mt-8 mb-8">
                <template v-slot:header>
                    <p class="mb-0" style="font-size: 21px">Actualización de la empresa</p>
                </template>
                <b-card-text>
                    <b-alert show variant="danger" v-if="errores">
                        <ul >
                            <li v-for="(item, index) in errors" :key="index">{{ item[0] }}</li>
                        </ul>
                    </b-alert>
                    <b-row>        
                        <b-col cols="12" md="6">
                            <ValidationProvider name="Nombre"  rules="required|min:3" v-slot="{ errors, valid }">
                                <b-form-group 
                                    label="Nombre empresa:"
                                    label-for="nombre">
                                    <b-form-input
                                        id="nombre"
                                        v-model="companyInfo.nombre"
                                        type="text"
                                        autocomplete="off"
                                        required
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        placeholder="Ingrese el nombre"
                                        ></b-form-input>
                                    <b-form-invalid-feedback>
                                        {{ errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12" md="6">
                            <ValidationProvider name="nit"  rules="required" v-slot="{ errors, valid }">
                                <b-form-group 
                                    label="Nit:"
                                    label-for="nit">
                                    <b-form-input
                                        id="nit"
                                        v-model="companyInfo.nit"
                                        type="text"
                                        autocomplete="off"
                                        required
                                        readonly
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        placeholder="Ingrese el Nit"
                                        ></b-form-input>
                                    <b-form-invalid-feedback>
                                        {{ errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12" md="6">
                            <ValidationProvider name="x_studio_id"  rules="required|min:2" v-slot="{ errors, valid }">
                                <b-form-group 
                                    label="X Studio ID:"
                                    label-for="x_studio_id">
                                    <b-form-input
                                        id="x_studio_id"
                                        v-model="companyInfo.x_studio_id"
                                        type="text"
                                        autocomplete="off"
                                        required
                                        readonly
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        placeholder="Ingrese el x studio ID"
                                        ></b-form-input>
                                    <b-form-invalid-feedback>
                                        {{ errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12" md="6">
                            <ValidationProvider name="supplier_price_list"  rules="required|min:2" v-slot="{ errors, valid }">
                                <b-form-group 
                                    label="Lista de precio:"
                                    label-for="supplier_price_list">
                                    <b-form-input
                                        id="supplier_price_list"
                                        v-model="companyInfo.supplier_price_list_reference"
                                        type="text"
                                        autocomplete="off"
                                        required
                                        readonly
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        placeholder="Ingrese la lista de precios
                                        8"
                                        ></b-form-input>
                                    <b-form-invalid-feedback>
                                        {{ errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                    </b-row>
                    <div>
                        <b-row v-for="(item, index) in permissionList" :key="index">
                            <b-col cols="12" md="12">
                                <p class="mb-0" style="font-size: 21px">{{index}}</p>
                            </b-col>
                            <b-col cols="6" md="4" v-for="(item, key) in item" :key="key">
                                    <b-form-checkbox
                                    v-model="permissions[key]"
                                    name="checkbox-1"
                                    :value=key.checked
                                    >
                                    {{item}}
                                </b-form-checkbox>
                            </b-col>
                        </b-row>
                    </div>
                    <hr />
                    <UpdateUserMasterForm :formData="userMaster" />
                </b-card-text>
                <template v-slot:footer>
                    <b-button variant="danger" class="mr-2" @click.prevent="back">
                        Cancelar
                    </b-button>
                    <b-button variant="success" :disabled="invalid" type="submit">
                        Actualizar
                    </b-button>
                </template>
            </b-card>
        </b-form>
    </ValidationObserver>
</template>
<script>
import UpdateUserMasterForm from '../components/UpdateUserMasterForm.vue';
import { mapMutations, mapState } from 'vuex'
export default {
    data(){
        return{
            companyInfo: {},
            userMaster: {},
            errors: {},
            errores: false,
            permissionList:{},
            permissions: [],
        }
    },
    components: {
        UpdateUserMasterForm
    },
    created(){
        this.getInfoCompany();
        this.getPermissionsList();
        
    },
    computed:{
        ...mapState('auth', ['user']),
        commissionOnSalesOptions() {
            return Array.from(Array(100).keys());
        },
    },
    methods:{
        ...mapMutations(['setLoading']),
        async getPermissionsList(){
            this.setLoading(true)
            await this.$conectar.post('/admin/empresas/get-available-permissions-list-empresa')
            .then(response=>{
                this.permissionList = response.data.permissions;
            })
            .catch(response =>{
                console.log(response);
            })
            this.setLoading(false)
        },
        async getInfoCompany(){
            this.setLoading(true)
            await this.$conectar.post('/admin/empresas/find-company',{
                id: this.$route.params.id
            })
            .then(response => {
                this.companyInfo = response.data.companyInfo;
                this.userMaster = response.data.userMaster;
                this.companyInfo.permissions.forEach(key => {
                    this.permissions[key] = true;
                });
            })
            .catch(e =>{
                console.log(e);
            })
            this.setLoading(false)
        },
        back(){
            this.$router.go(-1);
        },
        async updateCompany(){
            this.setLoading(true)
            this.permissionArray = [];
            for (var key in this.permissions) {
                if(this.permissions[key]){
                    this.permissionArray.push(key);
                }
            }

            this.companyInfo.permissions   = this.permissionArray;

            this.userMaster.userId = this.userMaster.id;

            const dataToSend = {
                ...this.companyInfo,
                userMaster: this.userMaster
            };

            await this.$conectar.post('/admin/empresas/update-company-information', dataToSend)
            .then(response=>{
                if(response.data.error == true){
                    this.errores = true;
                    this.errors = response.data.errors;
                }else{
                    this.$root.$bvToast.toast('Se actualizo la empresa correctamente', {
                        title: "Respuesta del servidor",
                        variant: "success",
                        solid: true
                    })
                    this.$router.push({ name: 'companiesList' });
                }
                })
            .catch(response =>{
                console.log(response);
                this.$bvToast.toast("Parece que hubo un error en el servidor", {
                    title: "Respuesta del servidor",
                    variant: "danger",
                    solid: true
                })
            })
            this.setLoading(false)
        },
    }
}
</script>
